import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";

import { useChatForm } from "./use-chat-form";

export const ChatFormStartRecordingVoiceButton = () => {
  const { startRecording, canEdit } = useChatForm();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button type="button" variant="secondary" size="xs" display="icon" onClick={startRecording} disabled={!canEdit}>
          <Icon icon="mic" className="filled" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Use microphone</TooltipContent>
    </Tooltip>
  );
};
